module.exports = __webpack_public_path__ + "img/menu-store-1.72997450.webp";